import service1Img from '../images/serviceCards/corporate.jpg'
import service2Img from '../images/serviceCards/catering.jpg'
import service3Img from '../images/serviceCards/birthday.jpg'
import service4Img from '../images/serviceCards/aniversary.jpg'
import service5Img from '../images/serviceCards/baby.jpg'
import service6Img from '../images/serviceCards/bar.jpg'


export const Services = [
    {
        serviceID:'1',
        title:'Corporate and conference',
        srcImg:service1Img,
        description:'We specialize in corporate event planning, offering tailored solutions for seamless conferences and meetings.'
    },
    {
        serviceID:'2',
        title:'Catering',
        srcImg:service2Img,
        description:'We offer exceptional catering services, ensuring delectable cuisine and memorable dining experiences for all occasions'
    },
    {
        serviceID:'3',
        title:'Birthday party planning',
        srcImg:service3Img,
        description:'We meticulously plan birthday celebrations, creating unforgettable moments with personalized themes and decorations'
    },
    {
        serviceID:'4',
        title:'Anniversary party planning',
        srcImg:service4Img,
        description:'We specialize in anniversary event planning, curating memorable experiences with thoughtful details and elegant decor'
    },
    {
        serviceID:'5',
        title:'Baby shower planning',
        srcImg:service5Img,
        description:'We craft beautiful baby shower celebrations, offering personalized themes, decor, and activities for an unforgettable experience'
    },
    {
        serviceID:'6',
        title:'Bar and bat mitzvah planning',
        srcImg:service6Img,
        description:'We meticulously plan Bar and Bat Mitzvah celebrations, ensuring every detail reflects tradition and creates lasting memories.'
    },

]